import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from "@angular/core";
import { KeyPressConstants } from "app/core/vo/app-constants";

@Component({
  selector: "app-quiz-acp",
  templateUrl: "./quiz-acp.component.html",
  styleUrls: ["./quiz-acp.component.scss"],
})
export class QuizAcpComponent implements OnInit, OnChanges {
  constructor(private changeDetection: ChangeDetectorRef) {}
  @Input() currentQuiz: any;
  @Input() disableOptions: boolean;
  @Input() disableSubmit: boolean = true;
  @Input() textDirection: string;
  @Input() choicesContainerStyle: string;
  @Input() choicesStyle: string;
  @Input() showOptionsWithAnswer: boolean;
  @Output() disableSubmitChange = new EventEmitter<boolean>();
  @Output() optionChanged = new EventEmitter<boolean>();

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges){
    this.changeDetection.detectChanges();
    if (changes["currentQuiz"] && (changes["currentQuiz"]["previousValue"] == undefined ||
      changes["currentQuiz"]["currentValue"]["index"] !=
      changes["currentQuiz"]["previousValue"]["index"])
    ) {
      if (changes["currentQuiz"]["currentValue"]["multichoice"]) {
        (document.querySelector(".checkBox") as HTMLElement).focus();
      } else {
        (document.querySelector(".radioBtn") as HTMLElement).focus();
      }
    }
  }

  public onKeyDownClick(event, choice) {
    const code = event.code;
    if (!this.currentQuiz.multichoice) {
      //radiobutton
      if (KeyPressConstants.KeyPressCodes.indexOf(code) == -1) return;
      else {
        choice = this.onRadioButtonKeyDown(code, choice);
        if (event.code != KeyPressConstants.TAB)
          this.changeCurrentStateOfChoice(choice);
      }
    } else {
      //checkbox
      if (
        code &&
        code !== KeyPressConstants.SPACE &&
        code !== KeyPressConstants.ENTER
      ) {
        return;
      } else {
        this.changeCurrentStateOfChoice(choice);
      }
    }
  }

  /* For RadioButton ,only one item should be focussable at a time.
   Only for first item, Enter key and Space Key should be allowed to select the item.
   else the radiobutton selection should happen by ArrowKeys.It should not get selected by Tab press.*/
  private onRadioButtonKeyDown(code, choice) {
    var choices = this.currentQuiz.choices;
    var radioButtons = document.querySelectorAll(".radioBtn");
    var length = choices.length;
    var nextChoice = choice;

    if (radioButtons.length > 0 && choices.length > 0) {
      var index = choices.indexOf(choice);
      if (
        code == KeyPressConstants.ARROWLEFT ||
        code == KeyPressConstants.ARROWUP
      ) {
        if (index == 0) {
          nextChoice = choices[length - 1];
          this.setTabIndexAndFocusForRadioButtons(radioButtons, length - 1);
        } else {
          nextChoice = choices[index - 1];
          this.setTabIndexAndFocusForRadioButtons(radioButtons, index - 1);
        }
      } else if (
        code == KeyPressConstants.ARROWRIGHT ||
        code == KeyPressConstants.ARROWDOWN
      ) {
        if (index == length - 1) {
          nextChoice = choices[0];
          this.setTabIndexAndFocusForRadioButtons(radioButtons, 0);
        } else {
          nextChoice = choices[index + 1];
          this.setTabIndexAndFocusForRadioButtons(radioButtons, index + 1);
        }
      } else if (
        code == KeyPressConstants.TAB ||
        code == KeyPressConstants.ENTER ||
        code == KeyPressConstants.SPACE
      ) {
        let isAnyOptionSelected =
          this.currentQuiz.choices.filter((item) => item.selected == true)
            .length > 0
            ? true
            : false;
        if (!isAnyOptionSelected && index == 0) {
          this.setTabIndexAndFocusForRadioButtons(radioButtons, index);
        }
      }
    }
    return nextChoice;
  }

  public onOptionClick(choice) {
    this.optionChanged.emit(choice);
    if (!this.currentQuiz.multichoice) {
      //radiobutton
      this.removeFocusForUnSelectedChoices(choice);
    }
    this.changeCurrentStateOfChoice(choice);
  }

  private removeFocusForUnSelectedChoices(choice) {
    let focusableIndex = this.currentQuiz.choices.indexOf(choice);
    if (focusableIndex > -1) {
      var radioButtons = document.querySelectorAll(".radioBtn");
      this.setTabIndexAndFocusForRadioButtons(radioButtons, focusableIndex);
    }
  }

  private setTabIndexAndFocusForRadioButtons(radioButtons, focusableIndex) {
    radioButtons.forEach((radio, index) => {
      if (index == focusableIndex) {
        radio.setAttribute("tabIndex", "0");
        (radio as HTMLElement).focus();
      } else {
        radio.setAttribute("tabIndex", "-1");
      }
    });
  }

  private changeCurrentStateOfChoice(choice) {
    if (!this.disableOptions) {
      if (this.currentQuiz.multichoice) {
        choice.selected = !choice.selected;
      } else {
        this.currentQuiz.choices.forEach((item) => {
          item.selected = false;
        });
        choice.selected = true;
      }
    }
    this.disableSubmit =
      this.currentQuiz.choices.filter((item) => item.selected == true).length >
      0
        ? false
        : true;
    this.disableSubmitChange.emit(this.disableSubmit);
  }
}
